module.exports = __webpack_public_path__ + "img/sec2_07.7b055122.png";